import { render, staticRenderFns } from "./MyModal.vue?vue&type=template&id=1a372e70&"
import script from "./MyModal.vue?vue&type=script&lang=js&"
export * from "./MyModal.vue?vue&type=script&lang=js&"
import style0 from "./MyModal.vue?vue&type=style&index=0&id=1a372e70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports